import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'deduct'})
export class DeductPipe implements PipeTransform {
    transform(value: number, taxCountry: string): number {
        if (taxCountry === 'France') {
            return value * (1 - 0.66);
        } else {
            return value;
        }
    }
}
